module.exports = __webpack_public_path__ + "static/media/cylinder_bottom_blue.32161771.png";